module.exports = __webpack_public_path__ + "static/media/transfer-in.de460baf.png";